@file:OptIn(InternalResourceApi::class)

package studio.oddpods.cauce.core.ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/studio.oddpods.cauce.core.ui.generated.resources/"

public val Res.string.core_ui_date_picker_confirm: StringResource by lazy {
      StringResource("string:core_ui_date_picker_confirm", "core_ui_date_picker_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 39),
      ))
    }

public val Res.string.core_ui_date_picker_dismiss: StringResource by lazy {
      StringResource("string:core_ui_date_picker_dismiss", "core_ui_date_picker_dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50, 47),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("core_ui_date_picker_confirm", Res.string.core_ui_date_picker_confirm)
  map.put("core_ui_date_picker_dismiss", Res.string.core_ui_date_picker_dismiss)
}
